export default __webpack_public_path__ + "static/media/cookie-monster-emoji.47441948.png";